/**
 * Модуль автоматического перевода с русского на английский
 * Работает только для основного сайта, не трогает админ-панель
 */

class Translation {
    constructor() {
        // Проверяем, не находимся ли мы в админ-панели
        this.isAdminPanel = window.location.pathname.includes('/admin') || 
                           window.location.pathname === '/admin' ||
                           document.querySelector('#adminContainer, #adminAuthModal');

        // Базовый язык интерфейса (всё исходно написано на русском)
        this.defaultLanguage = 'ru';

        // Полные словари переводов по целевым языкам
        this.allTranslations = {
            // Словарь для английского языка
            en: {
            // Основные элементы интерфейса
            'Гитарный тюнер с визуализацией грифа': 'Guitar Tuner with Fretboard Visualization',
            'Вход': 'Login',
            'Регистрация': 'Registration',
            'Логин': 'Username',
            'Пароль': 'Password',
            'Подтвердите пароль': 'Confirm Password',
            'Войти': 'Login',
            'Зарегистрироваться': 'Register',
            'Вход...': 'Logging in...',
            'Регистрация...': 'Registering...',
            'Нет аккаунта? Зарегистрироваться': 'No account? Register',
            'Уже есть аккаунт? Войти': 'Already have an account? Login',
            'Выйти': 'Logout',
            'Пользователь': 'User',
            'Песня': 'Song',
            'Песня не выбрана': 'No song selected',
            
            // Кнопки управления
            'Прослушать песню': 'Listen to Song',
            'Проиграть всё': 'Play All',
            'Стоп': 'Stop',
            'Гриф гитары': 'Guitar Fretboard',
            'Настройки': 'Settings',
            
            // Тюнер
            'Включить микрофон': 'Enable Microphone',
            'Подключите наушники для использования микрофона': 'Connect headphones to use microphone',
            'Остановить': 'Stop',
            'Выбор микрофона:': 'Microphone Selection:',
            'По умолчанию': 'Default',
            'Обновить список': 'Refresh List',
            'Целевая нота:': 'Target Note:',
            'Отклонение:': 'Deviation:',
            'Режим: Автоматический': 'Mode: Automatic',
            'Ближайшая нота:': 'Nearest Note:',
            'Авто': 'Auto',
            
            // Настройки
            'Отключить эффекты': 'Disable Effects',
            'Размер буфера FFT:': 'FFT Buffer Size:',
            'Чувствительность микрофона:': 'Microphone Sensitivity:',
            'Сбросить весь прогресс': 'Reset All Progress',
            
            // Последовательность нот
            'Блоки мелодии': 'Melody Blocks',
            'Полная последовательность мелодии': 'Full Melody Sequence',
            
            // Игровые сообщения
            'Песня завершена!': 'Song Completed!',
            'Точность:': 'Accuracy:',
            'Попаданий:': 'Hits:',
            'Закрыть': 'Close',
            'Готово!': 'Ready!',
            'Загрузка музыки...': 'Loading Music...',
            'Загрузка...': 'Loading...',
            
            // Сообщения об ошибках
            'Заполните все поля': 'Please fill in all fields',
            'Пароли не совпадают': 'Passwords do not match',
            'Пароль должен быть не менее 6 символов': 'Password must be at least 6 characters',
            'Ошибка при входе': 'Login Error',
            'Ошибка при регистрации': 'Registration Error',
            'Регистрация успешна! Теперь вы можете войти.': 'Registration successful! You can now login.',
            'Вы уверены, что хотите выйти?': 'Are you sure you want to logout?',
            'Вы уверены, что хотите сбросить весь прогресс? Это действие нельзя отменить.': 
                'Are you sure you want to reset all progress? This action cannot be undone.',
            'Произошла ошибка:': 'An error occurred:',
            'Ошибка инициализации приложения:': 'Application initialization error:',
            'Ошибка переинициализации приложения после входа:': 'Application reinitialization error after login:',
            'Ошибка при воспроизведении всей последовательности:': 'Error playing full sequence:',
            'Ошибка при воспроизведении трека:': 'Error playing track:',
            'Не удалось инициализировать Tone.js': 'Failed to initialize Tone.js',
            'Не удалось загрузить последовательность. Убедитесь, что данные доступны.': 
                'Failed to load sequence. Make sure data is available.',
            'Загрузка музыки не завершена': 'Music loading not completed',
            'Ошибка загрузки музыки:': 'Music loading error:',
            'Ошибка обновления информации о пользователе и песне:': 'Error updating user and song information:',
            
            // Игровые сообщения
            'Последовательность завершена!': 'Sequence Completed!',
            'Ошибка: последовательность не загружена': 'Error: sequence not loaded',
            'Аккорд:': 'Chord:',
            
            // Уровни игры
            'Вы успешно прошли нулевой уровень. Перейти к первому уровню (с ритмом)?': 
                'You have successfully completed level zero. Proceed to first level (with rhythm)?',
            'Остаться на нулевом уровне': 'Stay on level zero',
            'Перейти на первый уровень': 'Proceed to first level',
            'Вернуться на предыдущий уровень сложности?': 'Return to previous difficulty level?',
            'Вернуться на шаг назад': 'Step back',
            'Блок': 'Block',
            'Уровень': 'Level',
            'полностью пройден!': 'completed!',
            'Результат:': 'Result:',
            'Без длительности': 'No Duration',
            '25% скорости': '25% Speed',
            '50% скорости': '50% Speed',
            '75% скорости': '75% Speed',
            '100% скорости': '100% Speed',
            'Поздравляем!': 'Congratulations!',
            'Все уровни завершены': 'All levels completed',
            
            // Предупреждения
            'Для воспроизведения звука требуется взаимодействие со страницей. Нажмите в любом месте страницы.': 
                'Audio playback requires user interaction. Click anywhere on the page.',
            'Рекомендуем использовать ПК или ноутбук для комфортной игры.': 
                'We recommend using a PC or laptop for comfortable gameplay.',
            'Понятно': 'Got it',
            'MediaDevices API не поддерживается в этом браузере. Убедитесь, что вы используете современный браузер и загружаете страницу по HTTPS (или через localhost).':
                'MediaDevices API is not supported in this browser. Make sure you use a modern browser and load the page via HTTPS (or via localhost).',
            'Разрешите доступ к микрофону в настройках браузера.':
                'Allow microphone access in your browser settings.',
            'Выбранный микрофон не найден. Проверьте подключение или выберите другое устройство в настройках.':
                'The selected microphone was not found. Check the connection or choose another device in the settings.',
            'Не удалось получить доступ к выбранному микрофону. Возможно, он используется другим приложением.':
                'Could not access the selected microphone. It may be used by another application.',
            'Ошибка при перезапуске микрофона:':
                'Error restarting microphone:',
            'Попробуйте остановить и включить микрофон вручную.':
                'Try stopping and starting the microphone manually.',
            'Ошибка:': 'Error:',
            'В строю!': 'In tune!',
            'выше': 'higher',
            'ниже': 'lower',
            'центов': 'cents',
            'OK': 'OK',
            
            // Строки тюнера
            '-я': 'th',
            '1-я': '1st',
            '2-я': '2nd',
            '3-я': '3rd',
            '4-я': '4th',
            '5-я': '5th',
            '6-я': '6th',
            'Ближайшая нота:': 'Nearest Note:',
            'Режим: Автоматический': 'Mode: Automatic',
            
            // Tutorial (общие тексты)
            'Добро пожаловать!': 'Welcome!',
            'Это приложение поможет вам научиться играть на гитаре. Давайте пройдем краткий обзор основных функций.': 
                'This application will help you learn to play guitar. Let\'s take a quick overview of the main features.',
            'Переключение режимов': 'Mode Switching',
            'Используйте эту кнопку для переключения между режимом грифа гитары и настройками. В режиме грифа вы будете видеть ноты, которые нужно сыграть.': 
                'Use this button to switch between guitar fretboard mode and settings. In fretboard mode you will see notes that need to be played.',
            'Воспроизведение музыки': 'Music Playback',
            'Нажмите кнопку "Проиграть всё" чтобы начать игру. Ноты будут появляться на грифе, и вам нужно будет сыграть их на своей гитаре.': 
                'Click the "Play All" button to start the game. Notes will appear on the fretboard, and you need to play them on your guitar.',
            'Прослушать песню': 'Listen to Song',
            'Эта кнопка позволяет прослушать оригинальную композицию перед началом игры.': 
                'This button allows you to listen to the original composition before starting the game.',
            'Тюнер': 'Tuner',
            'Перейдите в настройки, чтобы использовать тюнер. Он поможет вам настроить гитару перед игрой.': 
                'Go to settings to use the tuner. It will help you tune your guitar before playing.',
            'Включение микрофона': 'Enable Microphone',
            'Для работы тюнера и игры вам нужно включить микрофон. Нажмите кнопку "Включить микрофон" и разрешите доступ в браузере.': 
                'To use the tuner and play, you need to enable the microphone. Click the "Enable Microphone" button and allow access in the browser.',
            'Готово!': 'Done!',
            'Теперь вы знаете основы работы с приложением. Удачи в обучении! Вы всегда можете перезапустить этот tutorial из настроек.': 
                'Now you know the basics of using the application. Good luck learning! You can always restart this tutorial from settings.',

            // Tutorial (конкретные тексты из tutorial.js)
            'Это приложение поможет тебе научиться играть на гитаре. Давай пройдем краткий обзор основных функций.':
                'This application will help you learn to play guitar. Let\'s take a quick overview of the main features.',
            'Блоки мелодии (едим слона по частям )))':
                'Melody blocks (we eat the elephant piece by piece)))',
            'Правильно, ты будешь играть песню частями, для начала пройди отдельные блоки.':
                'Exactly, you will play the song in parts. First, go through individual blocks.',
            'Блоки мелодии (продолжаем есть слона )))':
                'Melody blocks (keep eating the elephant)))',
            'Блоки можно проходить в любой последовательности. С каждым уровнем скорость будет нарастать. Как только ты пройдёшь блок с точностью более 90%, ты попадёшь на новый уровень!':
                'You can complete blocks in any order. With each level, the speed will increase. Once you pass a block with more than 90% accuracy, you will move to a new level!',
            'Полная последовательность':
                'Full sequence',
            'Пройденные блоки будут подсвечиваться, здесь ты можешь увидеть свой прогресс в изучении песни':
                'Completed blocks will be highlighted. Here you can see your progress in learning the song.',
            'После того как ты отработаешь все блоки, сможешь сыграть всю песню целиком!':
                'After you practice all the blocks, you will be able to play the whole song!',
            'Здесь ты можешь настроить свою гитару.':
                'Here you can set up your guitar.',
            'Этот раздел поможет тебе для точного определения нот':
                'This section will help you determine notes accurately.',
            'Для работы тюнера и комфортной игры тебе нужно включить микрофон. Нажми кнопку "Включить микрофон" и "разрешить доступ в браузере".':
                'To use the tuner and play comfortably, you need to enable the microphone. Click the "Enable Microphone" button and allow access in the browser.',
            'Теперь ты знаешь основы работы с приложением. Удачи в обучении! Ты всегда можешь вернуться к обучалке в верхней панеле.':
                'Now you know the basics of using the application. Good luck learning! You can always return to the tutorial from the top panel.',
            'Назад': 'Back',
            'Далее': 'Next',
            'Завершить': 'Finish',
            'Пропустить': 'Skip',
            'Перезапустить обучение': 'Restart Tutorial',

            // Прочие пользовательские сообщения
            'Переключить режим': 'Toggle mode',
            'Не удалось загрузить данные для этого блока!': 'Failed to load data for this block!',
            'Гитарный тюнер': 'Guitar tuner',
            'Старт': 'Start',
            'Стоп': 'Stop',
            'Ошибка доступа к микрофону:': 'Microphone access error:'
            }
            // Здесь в будущем можно добавить другие языки, например:
            // 'de': { ... }, 'es': { ... }
        };

        // Список поддерживаемых языков (включая базовый)
        this.supportedLanguages = [this.defaultLanguage, ...Object.keys(this.allTranslations)];

        // Определяем текущий язык (Telegram → браузер → базовый)
        this.currentLanguage = this.detectLanguage();

        // Активный словарь переводов для выбранного языка (null для базового)
        this.translations = this.allTranslations[this.currentLanguage] || null;
        
        // Если мы не в админке и выбран не базовый язык, применяем переводы
        if (!this.isAdminPanel && this.currentLanguage !== this.defaultLanguage && this.translations) {
            this.init();
        }
    }

    /**
     * Определяет язык интерфейса с учётом Telegram и настроек браузера
     * Приоритет:
     * 1) Язык Telegram Mini App (если запущено внутри Telegram)
     * 2) Язык браузера
     * 3) Базовый язык (ru)
     */
    detectLanguage() {
        // 1. Пытаемся получить язык из Telegram Mini App (приоритетнее браузера)
        try {
            if (typeof window !== 'undefined' && window.Telegram && window.Telegram.WebApp) {
                const tg = window.Telegram.WebApp;

                // Основной источник — i18n.language (соответствует языку интерфейса Telegram)
                const tgLangFromI18n = tg.i18n && tg.i18n.language;

                // Резервный источник — initDataUnsafe / language_code (на случай, если i18n недоступен)
                const tgLangFromInit =
                    (tg.initDataUnsafe && tg.initDataUnsafe.user && tg.initDataUnsafe.user.language_code) ||
                    (tg.initDataUnsafe && tg.initDataUnsafe.language_code) ||
                    tg.language_code ||
                    null;

                const tgLang = tgLangFromI18n || tgLangFromInit || null;
                const normalizedTgLang = this.normalizeLanguageCode(tgLang);
                if (normalizedTgLang) {
                    return normalizedTgLang;
                }
            }
        } catch (e) {
            // Безопасно игнорируем любые ошибки Telegram API
            console.warn('Failed to detect Telegram language:', e);
        }

        // 2. Язык браузера (используется, если мы НЕ в Telegram)
        const browserLang = (navigator.language || navigator.userLanguage || this.defaultLanguage);
        const normalizedBrowserLang = this.normalizeLanguageCode(browserLang);
        if (normalizedBrowserLang) {
            return normalizedBrowserLang;
        }

        // 3. Фоллбек — базовый язык
        return this.defaultLanguage;
    }

    /**
     * Нормализует код языка (например, 'en-US' → 'en') и проверяет, поддерживается ли он
     */
    normalizeLanguageCode(langCode) {
        if (!langCode || typeof langCode !== 'string') {
            return null;
        }

        const lower = langCode.toLowerCase();

        // Выделяем базовую часть до дефиса (например, 'en-us' → 'en')
        const base = lower.split('-')[0];

        // Поддерживаемые сейчас языки: ru, en
        if (base === 'ru') return 'ru';

        // Любой не-русский язык (включая de, es и т.д.) пока считаем английским,
        // чтобы приложение по умолчанию показывалось на EN для неподдерживаемых языков
        return 'en';
    }
    
    init() {
        // Переводим статический HTML контент при загрузке
        this.translateStaticContent();
        
        // Наблюдаем за изменениями DOM для динамического контента
        this.observeDOM();
        
        // Переводим текст через MutationObserver для динамически добавляемого контента
        this.setupMutationObserver();
    }
    
    /**
     * Переводит статический HTML контент
     */
    translateStaticContent() {
        // Переводим атрибуты title
        document.querySelectorAll('[title]').forEach(el => {
            if (el.title && this.translations[el.title]) {
                el.title = this.translations[el.title];
            }
        });
        
        // Переводим placeholder
        document.querySelectorAll('[placeholder]').forEach(el => {
            if (el.placeholder && this.translations[el.placeholder]) {
                el.placeholder = this.translations[el.placeholder];
            }
        });
        
        // Переводим текстовые узлы
        this.translateTextNodes(document.body);
        
        // Переводим alt атрибуты
        document.querySelectorAll('[alt]').forEach(el => {
            if (el.alt && this.translations[el.alt]) {
                el.alt = this.translations[el.alt];
            }
        });
    }
    
    /**
     * Рекурсивно переводит текстовые узлы
     */
    translateTextNodes(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            let text = node.textContent.trim();
            // Если для текущего языка нет словаря, ничего не делаем
            if (!this.translations) {
                return;
            }
            if (text && this.translations[text]) {
                node.textContent = this.translations[text];
            } else if (text) {
                // Проверяем частичные совпадения
                for (const [sourceText, translatedText] of Object.entries(this.translations)) {
                    if (text.includes(sourceText)) {
                        node.textContent = text.replace(new RegExp(sourceText, 'g'), translatedText);
                        break;
                    }
                }
            }
        } else {
            // Пропускаем скрипты и стили
            if (node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE' && node.tagName !== 'NOSCRIPT') {
                node.childNodes.forEach(child => this.translateTextNodes(child));
            }
        }
    }
    
    /**
     * Наблюдает за изменениями DOM для перевода динамического контента
     */
    observeDOM() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            // Переводим новые элементы
                            this.translateElement(node);
                        } else if (node.nodeType === Node.TEXT_NODE) {
                            this.translateTextNode(node);
                        }
                    });
                } else if (mutation.type === 'characterData') {
                    // Переводим измененный текст
                    this.translateTextNode(mutation.target);
                } else if (mutation.type === 'attributes') {
                    // Переводим измененные атрибуты
                    if (mutation.attributeName === 'title' || mutation.attributeName === 'placeholder') {
                        const element = mutation.target;
                        const value = element.getAttribute(mutation.attributeName);
                        if (value && this.translations[value]) {
                            element.setAttribute(mutation.attributeName, this.translations[value]);
                        }
                    }
                }
            });
        });
        
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['title', 'placeholder', 'alt']
        });
    }
    
    /**
     * Переводит элемент и его дочерние элементы
     */
    translateElement(element) {
        // Пропускаем скрипты и стили
        if (element.tagName === 'SCRIPT' || element.tagName === 'STYLE' || element.tagName === 'NOSCRIPT') {
            return;
        }
        
        // Переводим атрибуты
        ['title', 'placeholder', 'alt'].forEach(attr => {
            const value = element.getAttribute(attr);
            if (this.translations && value && this.translations[value]) {
                element.setAttribute(attr, this.translations[value]);
            }
        });
        
        // Переводим текстовые узлы
        element.childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                this.translateTextNode(node);
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                this.translateElement(node);
            }
        });
    }
    
    /**
     * Переводит текстовый узел
     */
    translateTextNode(node) {
        let text = node.textContent;
        if (!text || !text.trim()) return;
        
        // Прямое совпадение
        const trimmed = text.trim();
        if (this.translations && this.translations[trimmed]) {
            node.textContent = text.replace(trimmed, this.translations[trimmed]);
            return;
        }
        
        // Специальная обработка для номеров струн с суффиксом "-я" (например, "1-я", "2-я")
        const stringNumberPattern = /(\d+)-я/;
        if (stringNumberPattern.test(text)) {
            text = text.replace(stringNumberPattern, (match, num) => {
                const number = parseInt(num);
                if (number === 1) return '1st';
                if (number === 2) return '2nd';
                if (number === 3) return '3rd';
                return `${number}th`;
            });
            if (text !== node.textContent) {
                node.textContent = text;
                return;
            }
        }
        
        // Частичное совпадение - заменяем все вхождения
        let newText = text;
        if (this.translations) {
            for (const [sourceText, translatedText] of Object.entries(this.translations)) {
                if (text.includes(sourceText)) {
                    newText = newText.replace(new RegExp(this.escapeRegex(sourceText), 'g'), translatedText);
                }
            }
        }
        
        if (newText !== text) {
            node.textContent = newText;
        }
    }
    
    /**
     * Экранирует специальные символы для регулярного выражения
     */
    escapeRegex(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    
    /**
     * Настройка MutationObserver для отслеживания изменений текста
     */
    setupMutationObserver() {
        // Дополнительный observer для отслеживания изменений textContent
        const textObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'characterData' || mutation.type === 'childList') {
                    const target = mutation.target;
                    if (target.nodeType === Node.TEXT_NODE) {
                        this.translateTextNode(target);
                    } else if (target.nodeType === Node.ELEMENT_NODE) {
                        // Проверяем textContent элементов
                        if (target.textContent) {
                            const originalText = target.textContent;
                            let translatedText = originalText;
                            
                            if (this.translations) {
                                for (const [sourceText, translatedTextValue] of Object.entries(this.translations)) {
                                    if (translatedText.includes(sourceText)) {
                                        translatedText = translatedText.replace(new RegExp(this.escapeRegex(sourceText), 'g'), translatedTextValue);
                                    }
                                }
                            }
                            
                            if (translatedText !== originalText && target.childNodes.length === 1 && target.childNodes[0].nodeType === Node.TEXT_NODE) {
                                // Простой текстовый узел - заменяем безопасно
                                const newText = this.translateText(originalText);
                                if (newText !== originalText) {
                                    target.textContent = newText;
                                }
                            }
                        }
                    }
                }
            });
        });
        
        textObserver.observe(document.body, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }
    
    /**
     * Переводит текст (публичный метод для использования в других модулях)
     */
    translateText(text) {
        if (!text || typeof text !== 'string') return text;

        // Если выбран базовый язык или нет словаря переводов — возвращаем исходный текст
        if (!this.translations || this.currentLanguage === this.defaultLanguage) {
            return text;
        }
        
        // Прямое совпадение
        if (this.translations[text]) {
            return this.translations[text];
        }
        
        // Специальная обработка для номеров струн с суффиксом "-я" (например, "1-я", "2-я")
        const stringNumberPattern = /(\d+)-я/;
        if (stringNumberPattern.test(text)) {
            text = text.replace(stringNumberPattern, (match, num) => {
                const number = parseInt(num);
                if (number === 1) return '1st';
                if (number === 2) return '2nd';
                if (number === 3) return '3rd';
                return `${number}th`;
            });
        }
        
        // Частичное совпадение
        let translated = text;
        for (const [ru, en] of Object.entries(this.translations)) {
            if (translated.includes(ru)) {
                translated = translated.replace(new RegExp(this.escapeRegex(ru), 'g'), en);
            }
        }
        
        return translated;
    }
    
    /**
     * Добавляет или обновляет перевод
     */
    addTranslation(russian, english) {
        // Добавляем перевод только для текущего языка, если он не базовый
        if (this.currentLanguage === this.defaultLanguage) {
            return;
        }

        if (!this.allTranslations[this.currentLanguage]) {
            this.allTranslations[this.currentLanguage] = {};
        }

        this.allTranslations[this.currentLanguage][russian] = english;

        // Обновляем активный словарь
        this.translations = this.allTranslations[this.currentLanguage];
    }
}

// Создаем глобальный экземпляр переводчика
let translator = null;

// Инициализируем переводчик после загрузки DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        translator = new Translation();
        window.translator = translator; // Делаем доступным глобально
    });
} else {
    translator = new Translation();
    window.translator = translator; // Делаем доступным глобально
}

// Экспортируем класс и функцию перевода для использования в других модулях
export default Translation;
export function translate(text) {
    if (window.translator) {
        return window.translator.translateText(text);
    }
    return text;
}
